import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Member-access tour for organization member details.
 * Covers header, tabs, and access controls (lifecycle + instance).
 */
export const orgMemberDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_OrgMember_Welcome_Title"),
    description: t("Tour_OrgMember_Welcome_Description"),
    target: () => queryTourTarget("org-member-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_OrgMember_Tabs_Title"),
    description: t("Tour_OrgMember_Tabs_Description"),
    target: () => queryTourTarget("org-member-tabs"),
    placement: "bottom",
  },
  {
    title: t("Tour_OrgMember_Access_Title"),
    description: t("Tour_OrgMember_Access_Description"),
    target: () =>
      queryTourTarget("org-member-access-content") ??
      queryTourTarget("org-member-tabs"),
    placement: "top",
  },
];
